import { Report } from '@/api/generatedApi';
import { useGetReport } from '@/hooks/api/reports/useGetReport';
import { LIST_REPORTS_QUERY_KEY } from '@/hooks/api/reports/useFetchListReports';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { REPORT_POLL_INTERVAL_MS } from './pollingConstants';
import { isReportInProgress } from '@/utils/reportStatus';

export const useReportPolling = (parameters: { row: Report }) => {
  const queryClient = useQueryClient();
  const wasInProgressReference = useRef(isReportInProgress(parameters.row.status));

  const { report: fetchedReport } = useGetReport({
    id: wasInProgressReference.current ? parameters.row.id : undefined,
    refetchInterval: query => {
      const latest = query.state.data?.data.report;
      return isReportInProgress(latest?.status ?? parameters.row.status) ? REPORT_POLL_INTERVAL_MS : false;
    },
  });

  useEffect(() => {
    if (fetchedReport && wasInProgressReference.current && !isReportInProgress(fetchedReport.status)) {
      wasInProgressReference.current = false;
      queryClient.resetQueries({ queryKey: [LIST_REPORTS_QUERY_KEY], exact: false });
    }
  }, [fetchedReport, queryClient]);

  return { data: fetchedReport ?? parameters.row, fetchedData: fetchedReport };
};
